import { apiClient, orgApiPath } from '@/core/api';
import type { Campaign } from '@/types/api';

export interface CampaignCreateBody {
  name: string;
  narrative?: string | null;
}

export interface CampaignUpdateBody {
  name?: string | null;
  narrative?: string | null;
}

export async function listCampaigns(offset = 0, limit = 50): Promise<Campaign[]> {
  return apiClient<Campaign[]>(orgApiPath(`/campaigns?offset=${offset}&limit=${limit}`));
}

export async function getCampaign(id: number): Promise<Campaign> {
  return apiClient<Campaign>(orgApiPath(`/campaigns/${id}`));
}

export async function createCampaign(body: CampaignCreateBody): Promise<Campaign> {
  return apiClient<Campaign>(orgApiPath('/campaigns'), {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

export async function updateCampaign(id: number, body: CampaignUpdateBody): Promise<Campaign> {
  return apiClient<Campaign>(orgApiPath(`/campaigns/${id}`), {
    method: 'PATCH',
    body: JSON.stringify(body),
  });
}

export async function deleteCampaign(id: number): Promise<void> {
  return apiClient<void>(orgApiPath(`/campaigns/${id}`), {
    method: 'DELETE',
  });
}
